


import React, { Fragment } from "react";
import { useAuditItem } from "../../data/audits/useAuditItem";
import { IAuditItem } from "../../interfaces/IAuditItem";

type IRenderProps = { item: IAuditItem };

interface RenderAuditItemProps {
    itemId: number;
    render: (props: IRenderProps) => any;
};

export const RenderAuditItem: React.FC<RenderAuditItemProps> = ({ itemId, render }) => {

    const { data: item } = useAuditItem(itemId);

    if (!item) {
        return <div>Tietuetta ei löytynyt</div>
    }

    return (
        <Fragment>
            {render({ item })}
        </Fragment>
    )
};

